module.exports = __webpack_public_path__ + "static/coordinateGettingHelp-318b585dc7cbcc14a1f0b769713183a0.svg";